export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./games.vue?vue&type=template&id=52e611e8"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/softgamings/games.vue?vue&type=template&id=52e611e8
// module id = zztS
// module chunks = 0